import React, { useState } from "react";
import Modal from "components/commons/modal/Modal";
import { strings } from "intl/fa";
import { NewButtonVariant, Skeleton } from "@bale/ui";
import commonStyles from "./../Login.module.scss";
import styles from "./HintModal.module.scss";
import { replaceWithJsx } from "utils/utils";
import { PANEL_LINKS } from "utils/constants";

interface Props {
  onClose: () => void;
}

const HintModal = ({ onClose }: Props) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <Modal
      title={strings.login.login_guide_modal.title}
      primaryButton={{
        onClick: onClose,
        label: strings.common.button.understood,
        variant: NewButtonVariant.OUTLINED,
      }}
      onClose={onClose}
    >
      <div className={styles.HintModal}>
        <div className={styles.texts}>
          {strings.login.login_guide_modal.steps.map((step, index) =>
            index === 0 ? (
              <p>
                {replaceWithJsx(step, {
                  "{web}": (
                    <a
                      href={PANEL_LINKS.WEB}
                      className={commonStyles.Link}
                      target="__blank"
                    >
                      {strings.login.login_guide_modal.bale_web}
                    </a>
                  ),
                })}
              </p>
            ) : (
              <p>{step}</p>
            )
          )}
        </div>

        <img
          src="/images/loginHelp.png"
          alt="loginHelp"
          style={{ width: loaded ? undefined : 0 }}
          onLoad={() => setLoaded(true)}
        />
        {!loaded && <Skeleton width="100%" height="184px" type="rectangular" />}
      </div>
    </Modal>
  );
};

export default HintModal;
